import { AssignmentModel } from 'api/model';
import { useMemo } from 'react';
import { formatTime } from 'utils/date-helpers';

export default function useEstimatedWorkTime(assignment: AssignmentModel) {
  const estimatedDuration = assignment.estimatedDuration ?? 0;
  const estimatedLoadingTime = assignment.estimatedLoadingTime ?? 0;
  const estimatedUnloadingTime = assignment.estimatedUnloadingTime ?? 0;
  // Elbilars laddbuffert är belagd (icke-körande) tid precis som lossning — utan den
  // hamnar resulterande sluttid före det slot planeringen/körtidspolicyn reserverar.
  const electricCarBufferTime = assignment.electricCarBufferTime ?? 0;

  const estimatedWorkTimeMillis = useMemo(() => {
    // if this is a car transport, pad the work hours with the total amount of time for loading / unloading the cars
    return (
      estimatedDuration +
      estimatedLoadingTime +
      estimatedUnloadingTime +
      electricCarBufferTime
    );
  }, [
    estimatedDuration,
    estimatedLoadingTime,
    estimatedUnloadingTime,
    electricCarBufferTime,
  ]);

  const estimatedWorkStartTime =
    assignment.startTime ?? assignment.estimatedStartTime;
  const estimatedWorkEndTime = useMemo(() => {
    if (assignment.endTime) {
      return assignment.endTime;
    }
    const startTime = estimatedWorkStartTime;
    if (!startTime) {
      return undefined;
    }
    const startDate = new Date(startTime);
    const endDate = new Date(startDate.getTime() + estimatedWorkTimeMillis);
    // if the end date is in the future, set it to the end date
    return endDate;
  }, [estimatedWorkStartTime, estimatedWorkTimeMillis, assignment.endTime]);

  const estimatedWorkStartAndEndString = useMemo(
    () =>
      `${estimatedWorkStartTime ? formatTime(estimatedWorkStartTime) : '-'} - ${estimatedWorkEndTime ? formatTime(estimatedWorkEndTime) : '-'}`,
    [estimatedWorkStartTime, estimatedWorkEndTime]
  );

  return {
    estimatedWorkTimeMillis,
    estimatedWorkStartTime,
    estimatedWorkEndTime,
    estimatedWorkStartAndEndString,
  };
}
